import { render, staticRenderFns } from "./SheetCardMeal.vue?vue&type=template&id=3719f7c4&"
import script from "./SheetCardMeal.vue?vue&type=script&lang=js&"
export * from "./SheetCardMeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports